import Vue from 'vue'

export function useDepartmentMention(fetchApi) {
  const state = Vue.observable({
    deptVisible: false,
    deptKeyword: '',
    deptActiveIdx: 0,
    deptAnchorPos: -1,
    filteredDepartments: [],
    loading: false
  })

  // 缓存所有部门，避免重复请求
  let cachedDepartments = null

  let blurTimer = null
  let debounceTimer = null

  const clearBlurTimer = () => {
    if (blurTimer) { clearTimeout(blurTimer); blurTimer = null }
  }

  const clearDebounceTimer = () => {
    if (debounceTimer) { clearTimeout(debounceTimer); debounceTimer = null }
  }

  const loadDepartments = async () => {
    if (!fetchApi || !state.deptVisible) return
    if (cachedDepartments) {
      filterLocal(cachedDepartments)
      return
    }
    state.loading = true
    try {
      const resp = await fetchApi()
      const list = resp && resp.result ? resp.result : (resp && resp.data ? resp.data : [])
      cachedDepartments = list
      filterLocal(list)
    } catch (err) {
      cachedDepartments = []
      state.filteredDepartments = []
    } finally {
      state.loading = false
    }
  }

  const filterLocal = (list) => {
    const keyword = state.deptKeyword
    if (!keyword) {
      state.filteredDepartments = list || []
    } else {
      const lower = keyword.toLowerCase()
      state.filteredDepartments = (list || []).filter(dept =>
        (dept.name || dept.label || '').toLowerCase().includes(lower)
      )
    }
  }

  const detectDepartment = (value, cursorPos) => {
    const textBefore = value.slice(0, cursorPos)
    const lastHashIdx = textBefore.lastIndexOf('#')

    if (lastHashIdx === -1) {
      clearDebounceTimer()
      closeDepartment()
      return
    }

    const query = textBefore.slice(lastHashIdx + 1)

    // #后面包含空格或换行，说明 # 提及已结束
    if (query.includes(' ') || query.includes('\n')) {
      clearDebounceTimer()
      closeDepartment()
      return
    }

    state.deptAnchorPos = lastHashIdx
    state.deptKeyword = query
    state.deptActiveIdx = 0
    state.deptVisible = true

    if (cachedDepartments) {
      filterLocal(cachedDepartments)
    } else {
      // 防抖，避免频繁请求
      clearDebounceTimer()
      debounceTimer = setTimeout(() => { loadDepartments() }, 200)
    }
  }

  const closeDepartment = () => {
    clearBlurTimer()
    clearDebounceTimer()
    state.loading = false
    state.deptVisible = false
    state.deptKeyword = ''
    state.deptActiveIdx = 0
    state.deptAnchorPos = -1
    state.filteredDepartments = []
  }

  const scheduleClose = () => {
    if (!state.deptVisible) return
    clearBlurTimer()
    blurTimer = setTimeout(() => { closeDepartment() }, 150)
  }

  const selectDepartment = (dept) => {
    clearBlurTimer()
    const deptName = dept.name || dept.label || ''
    const displayName = `#${deptName} `
    const result = {
      anchorPos: state.deptAnchorPos,
      displayName,
      cursorAfter: state.deptAnchorPos + displayName.length
    }
    closeDepartment()
    return result
  }

  const moveUp = () => { state.deptActiveIdx = Math.max(0, state.deptActiveIdx - 1) }

  const moveDown = () => {
    state.deptActiveIdx = Math.min(state.filteredDepartments.length - 1, state.deptActiveIdx + 1)
  }

  const confirmSelection = () => {
    if (!state.deptVisible || state.filteredDepartments.length === 0) return null
    return selectDepartment(state.filteredDepartments[state.deptActiveIdx])
  }

  return {
    state,
    detectDepartment,
    closeDepartment,
    scheduleClose,
    selectDepartment,
    moveUp,
    moveDown,
    confirmSelection
  }
}